import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CHROME_OVERLAY_Z } from '../navigation/navTokens';

interface LogoutConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const LogoutConfirmationDialog: React.FC<LogoutConfirmationDialogProps> = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} aria-labelledby="logout-confirm-title" aria-describedby="logout-confirm-description" sx={{ zIndex: CHROME_OVERLAY_Z + 1 }}
    maxWidth="xs" fullWidth slotProps={{ paper: { sx: { borderRadius: 3, backgroundImage: 'none' } } }}>
    <DialogTitle id="logout-confirm-title" sx={{ fontSize: '1.125rem', fontWeight: 600, pb: 1 }}>Sair da conta?</DialogTitle>
    <DialogContent>
      <DialogContentText id="logout-confirm-description">Você precisará entrar novamente para acessar o Mestti.</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5, gap: 1, '& .MuiButton-root': { textTransform: 'none', borderRadius: '8px', boxShadow: 'none' } }}>
      <Button onClick={onClose} autoFocus>Cancelar</Button>
      <Button color="error" variant="contained" onClick={onConfirm}>Sair da conta</Button>
    </DialogActions>
  </Dialog>
);
